import React, { useEffect, useState } from "react";
import { Modal, Select, Button } from "antd";
const { Option } = Select;

const BatchModal = (props) => {
  const [batchId, setBatchId] = useState(null);
  useEffect(() => {
    setBatchId(props.riderBatchId);
  }, [props.riderBatchId]);

  return (
    <Modal
      title={props.RiderName}
      visible={props.assignBatchModal}
      // onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={[
        <Button key="submit" type="default" onClick={props.handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={props.showBatchSubmitLoder == true ? true:false} onClick={props.handleOk}>
          OK
        </Button>,
      ]}
    >
      <Select
        // defaultValue={props.riderBatchId}
        onChange={props.riderBatchChange}
        value={props.value}
        // firstActiveValue={props.riderBatchId}
        placeholder="Select Batch"
        style={{ width: "100%" }}
      >
        {props.postDatabatch &&
          props.postDatabatch.map((item) => (
            <Option value={item.batch.id}>{item.batch.batchLevel}</Option>
          ))}
      </Select>
    </Modal>
  );
};

export default BatchModal;
